import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { canExportWeeklyReport } from "./weeklyReportModel";
import { exportWeeklyReportPdf } from "./exportWeeklyReportPdf";

const useWeeklyReportExport = ({
  periodHistoryStart,
  periodHistoryStop,
  keywordFilter,
  selectedSiteKey,
  siteOptions,
  numberOfSite,
}) => {
  const { t } = useTranslation();
  const [isExporting, setIsExporting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressLabel, setProgressLabel] = useState("");

  const siteGate = canExportWeeklyReport({
    selectedSiteKey,
    siteOptions,
    numberOfSite,
  });
  const selectedSiteName =
    siteOptions.find((site) => site.key === selectedSiteKey)?.name ||
    siteOptions[0]?.name ||
    "";

  const exportWeeklyReport = async () => {
    if (isExporting) return;
    if (!periodHistoryStart || !periodHistoryStop) return;
    if (!siteGate.ok) {
      toast.error(t("weeklyReport.needOneSite"), { className: "custom-toast" });
      return;
    }

    setIsExporting(true);
    setProgress(0);
    setProgressLabel(t("weeklyReport.progress.stats"));
    try {
      await exportWeeklyReportPdf({
        periodStart: periodHistoryStart,
        periodStop: periodHistoryStop,
        keywordFilter,
        siteName: selectedSiteName,
        t,
        onProgress: ({ percent, label }) => {
          setProgress(percent);
          setProgressLabel(label);
        },
      });
      toast.success(t("weeklyReport.exportSuccess"), {
        className: "custom-toast",
      });
    } catch (error) {
      console.error("Weekly report export failed:", error);
      toast.error(t("weeklyReport.exportError"), { className: "custom-toast" });
    } finally {
      setIsExporting(false);
      setProgress(0);
      setProgressLabel("");
    }
  };

  return {
    exportWeeklyReport,
    canExport: siteGate.ok,
    isExporting,
    progress,
    progressLabel,
  };
};

export default useWeeklyReportExport;
